import { config } from '_appConfig'

import { initAmplitude, InitAmplitudeEnvEnum } from './amplitude'
import { initSentry } from './sentry'

// import { initUserGuiding } from './userguiding'

export const initAnalytics = () => {
  try {
    if (['production', 'uat'].includes(config.default.environment)) {
      initAmplitude(InitAmplitudeEnvEnum.PRODUCTION)
    } else {
      initAmplitude(InitAmplitudeEnvEnum.DEVELOPMENT)
    }

    if (['app', 'production', 'release'].includes(config.default.environment)) {
      initSentry()
    }

    // initUserGuiding()

    // initAmplitude()
    // initSentry()
  } catch (e) {
    console.error('Error initAnalytics', e)
  }
}
